import { useOnline } from "@vueuse/core";

export default useOnline();
